import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';
import chartExplainTw from '@/assets/img/ChartExplain-zhtw.png';
import chartExplainEn from '@/assets/img/ChartExplain-en.png';
import chartExplainCn from '@/assets/img/ChartExplain-cn.png';

import informationEditTw from '@/assets/img/informationEdit-zhtw.png';
import informationEditEn from '@/assets/img/informationEdit-en.png';
import informationEditCn from '@/assets/img/informationEdit-cn.png';

import hidePointOpenTw from '@/assets/img/hidePointOpen-zhtw.png';
import hidePointOpenEn from '@/assets/img/hidePointOpen-en.png';
import hidePointOpenCn from '@/assets/img/hidePointOpen-cn.png';

import chartSamplePointTw from '@/assets/img/chartSamplePoint-zhtw.png';
import chartSamplePointEn from '@/assets/img/chartSamplePoint-en.png';
import chartSamplePointCn from '@/assets/img/chartSamplePoint-cn.png';

import editMeasureValueTw from '@/assets/img/editMeasureValue-zhtw.png';
import editMeasureValueEn from '@/assets/img/editMeasureValue-en.png';
import editMeasureValueCn from '@/assets/img/editMeasureValue-cn.png';

import multiDataImportTw from '@/assets/img/multiDataImport-zhtw.png';
import multiDataImportEn from '@/assets/img/multiDataImport-en.png';
import multiDataImportCn from '@/assets/img/multiDataImport-cn.png';

import combineChartTw from '@/assets/img/combineChart-zhtw.png';
import combineChartEn from '@/assets/img/combineChart-en.png';
import combineChartCn from '@/assets/img/combineChart-cn.png';

import hiddenPointProcessingTw from '@/assets/img/HiddenPointProcessing-zhtw.png';
import hiddenPointProcessingEn from '@/assets/img/HiddenPointProcessing-en.png';
import hiddenPointProcessingCn from '@/assets/img/HiddenPointProcessing-cn.png';

import advanceSearchDynamicFields from '@/assets/img/advanceSearchDynamicFields.png';

import CPKBoxImg from '@/assets/img/CPK-Box.png';
import runChartImg from '@/assets/img/RunChart.png';

import videoMenuOtherFunctionTw from '@/assets/video/videoMenuOtherFunction-tw.mp4';
import videoMenuOtherFunctionEn from '@/assets/video/videoMenuOtherFunction-en.mp4';
import videoMenuOtherFunctionCn from '@/assets/video/videoMenuOtherFunction-cn.mp4';

import paretoImg from '@/assets/img/Pareto.png';

import sampleMngListTw from '@/assets/img/sampleMngList-zhtw.png';
import sampleMngListEn from '@/assets/img/sampleMngList-en.png';
import sampleMngListCn from '@/assets/img/sampleMngList-cn.png';

import xBarChartSettingTw from '@/assets/img/controlChart/XBarChartSetting-tw.png';
import xBarChartSettingEn from '@/assets/img/controlChart/XBarChartSetting-en.png';
import xBarChartSettingTw2 from '@/assets/img/controlChart/XBarChartSetting-step2-tw.png';
import xBarChartSettingEn2 from '@/assets/img/controlChart/XBarChartSetting-step2-en.png';
import XBarChartInputDataTw1 from '@/assets/img/controlChart/XBarChartInputData-tw.png';
import XBarChartInputDataEn1 from '@/assets/img/controlChart/XBarChartInputData-en.png';
import XBarChartInputDataTw2 from '@/assets/img/controlChart/XBarChartInputData2-tw.png';
import XBarChartInputDataEn2 from '@/assets/img/controlChart/XBarChartInputData2-en.png';
import XBarChartInputDataTw3 from '@/assets/img/controlChart/XBarChartInputData3-tw.png';
import XBarChartInputDataEn3 from '@/assets/img/controlChart/XBarChartInputData3-en.png';
import XBarChartInputDataTw4 from '@/assets/img/controlChart/XBarChartInputData4-tw.png';
import XBarChartInputDataEn4 from '@/assets/img/controlChart/XBarChartInputData4-en.png';
import XBarChartInputDataTw5 from '@/assets/img/controlChart/XBarChartInputData5-tw.png';
import XBarChartInputDataEn5 from '@/assets/img/controlChart/XBarChartInputData5-en.png';
import XBarChartIResultTw from '@/assets/img/controlChart/XBarChartIResult-tw.png';
import XBarChartIResultEn from '@/assets/img/controlChart/XBarChartIResult-en.png';

/**
 * 呼叫篩選管制項目之樹狀選單
 * @param {*} i18n
 */
export function callHelpFilterControlItemTree(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.filterRegion',
        popover: {
          title: i18n.$t('ControlItem').Setting.filter,
          description: i18n.$t('ControlItem').Setting.filterDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫新增管制項目
 * @param {*} i18n
 */
export function callHelpCreateControlItem(i18n, store) {
  const driverObj = driver({
    // showProgress: true,
    animate: true,
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#selectedTab',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('ControlItem').Setting.createDescription,
          onNextClick: () => {
            if (store.state.controlItem.tabShow === 'add') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);

              window.scrollToTop();
            }
          },
        },
      },

      {
        element: '.must1',
        popover: {
          title: i18n.$t('ControlItem').Setting.controlItemName,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput} "\\/[]!@#$%^&*()+</p>`,
        },
      },

      {
        element: '.status',
        popover: {
          title: i18n.$t('ControlItem').Setting.status,
          description: i18n.$t('ControlItem').Setting.statusExplain,
        },
      },

      {
        element: '.must2',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '.sampleCapacity',
        popover: {
          title: i18n.$t('ControlItem').Setting.sampleCapacity,
          description: i18n.$t('ControlItem').Setting.sampleCapacityExplain,
        },
      },

      {
        element: '.sampleAmount',
        popover: {
          title: i18n.$t('ControlItem').Setting.sampleAmount,
          description: i18n.$t('ControlItem').Setting.sampleAmountExplain,
        },
      },

      {
        element: '.supportDecimal',
        popover: {
          title: i18n.$t('ControlItem').Setting.supportDecimal,
          description: i18n.$t('ControlItem').Setting.supportDecimalExplain,
        },
      },

      {
        element: '#standardSample',
        popover: {
          title: i18n.$t('ControlItem').Setting.standardSample,
          description: i18n.$t('ControlItem').Setting.standardSampleExplain,
        },
      },

      {
        element: '.U_T_L',
        popover: {
          title: i18n.$t('ControlItem').Setting.USLTargetLSL,
          description: i18n.$t('ControlItem').Setting.USLTargetLSLExplain,
        },
      },

      {
        element: '#updateFrequency',
        popover: {
          title: i18n.$t('ControlItem').Setting.updateFrequency,
          description: i18n.$t('ControlItem').Setting.updateFrequencyExplain,
        },
      },

      {
        element: '#customUpdateFrequency',
        popover: {
          title: i18n.$t('ControlItem').Setting.customUpdateFrequency,
          description: i18n.$t('ControlItem').Setting.customUpdateFrequencyExplain,
        },
      },

      {
        element: '#produceLevel',
        popover: {
          title: i18n.$t('ControlItem').Setting.processLevel,
          description: i18n.$t('ControlItem').Setting.processLevelExplain,
        },
      },

      {
        element: '#alertNotification',
        popover: {
          title: i18n.$t('ControlItem').Setting.alertNotification,
          description: i18n.$t('ControlItem').Setting.alertNotificationExplain,
        },
      },

      {
        element: '#threeAlert',
        popover: {
          title: i18n.$t('ControlItem').Setting.threeAlert,
          description: i18n.$t('ControlItem').Setting.threeAlertExplain,
        },
      },

      {
        element: '#autoLock',
        popover: {
          title: i18n.$t('ControlItem').Setting.autoLock,
          description: i18n.$t('ControlItem').Setting.autoLockExplain,
        },
      },

      {
        element: '#processReportCalculation',
        popover: {
          title: i18n.$t('ControlItem').Setting.processReportCalculation,
          description: i18n.$t('ControlItem').Setting.processReportCalculationExplain,
        },
      },

      {
        element: '#threeProcess',
        popover: {
          title: i18n.$t('ControlItem').Setting.threeProcess,
          description: i18n.$t('ControlItem').Setting.threeProcessExplain,
        },
      },

      {
        element: '#dynamiCcolumnSelect',
        popover: {
          title: i18n.$t('ControlItem').Setting.dynamiCcolumnSelect,
          description: `
          <p>${i18n.$t('ControlItem').Setting.dynamiCcolumnSelectExplain}</p>
          <p>${i18n.$t('ControlItem').Setting.dataImport}</p>
          <p>${i18n.$t('ControlItem').Setting.importMethod}</p>`,
        },
      },

      {
        element: '#controlChartSetting',
        popover: {
          title: i18n.$t('ControlItem').Setting.controlChartSetting,
          description: i18n.$t('ControlItem').Setting.controlChartSettingExplain,
        },
      },

      {
        element: '#dataType',
        popover: {
          title: i18n.$t('ControlItem').Setting.dataType,
          description: i18n.$t('ControlItem').Setting.dataTypeExplain,
        },
      },

      {
        element: '#calculateMethod',
        popover: {
          title: i18n.$t('ControlItem').Setting.calculateMethod,
          description: i18n.$t('ControlItem').Setting.calculateMethodExplain,
        },
      },

      {
        element: '#chartList',
        popover: {
          title: i18n.$t('ControlItem').Setting.chartList,
          description: i18n.$t('ControlItem').Setting.chartListExplain,
          onNextClick: () => {
            if (store.state.controlItem.chartIDList.length > 0) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').checkSelectData,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(22);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#calculateModel',
        popover: {
          title: i18n.$t('ControlItem').Setting.calculateModel,
          description: i18n.$t('ControlItem').Setting.calculateModelExplain,
        },
      },

      {
        element: '#stopABC',
        popover: {
          title: i18n.$t('ControlItem').Setting.stopABC,
          description: i18n.$t('ControlItem').Setting.stopABCExplain,
        },
      },

      {
        element: '#UCL_LCL_Custom',
        popover: {
          title: i18n.$t('ControlItem').Setting.UCL_LCL_Custom,
          description: i18n.$t('ControlItem').Setting.UCL_LCL_CustomExplain,
        },
      },

      {
        element: '#ControlChartRule',
        popover: {
          title: i18n.$t('ControlItem').Setting.ControlChartRule,
          description: i18n.$t('ControlItem').Setting.ControlChartRuleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 改用 A_1_V1.vue 後的呼叫新增管制項目
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpCreateControlItemV1(i18n, store) {
  const driverObj = driver({
    animate: true,
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#addControlItemBtn',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('ControlItem').Setting.createDescription,
          onNextClick: () => {
            if (store.state.controlItem.createEditDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);

              window.scrollToTop();
            }
          },
        },
      },

      {
        element: '.must1',
        popover: {
          title: i18n.$t('ControlItem').Setting.controlItemName,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput} "\\/[]!@#$%^&*()+</p>`,
        },
      },

      {
        element: '.status',
        popover: {
          title: i18n.$t('ControlItem').Setting.status,
          description: i18n.$t('ControlItem').Setting.statusExplain,
        },
      },

      {
        element: '.must2',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '.sampleCapacity',
        popover: {
          title: i18n.$t('ControlItem').Setting.sampleCapacity,
          description: i18n.$t('ControlItem').Setting.sampleCapacityExplain,
        },
      },

      {
        element: '.sampleAmount',
        popover: {
          title: i18n.$t('ControlItem').Setting.sampleAmount,
          description: i18n.$t('ControlItem').Setting.sampleAmountExplain,
        },
      },

      {
        element: '.supportDecimal',
        popover: {
          title: i18n.$t('ControlItem').Setting.supportDecimal,
          description: i18n.$t('ControlItem').Setting.supportDecimalExplain,
        },
      },

      {
        element: '#standardSample',
        popover: {
          title: i18n.$t('ControlItem').Setting.standardSample,
          description: i18n.$t('ControlItem').Setting.standardSampleExplain,
        },
      },

      {
        element: '.U_T_L',
        popover: {
          title: i18n.$t('ControlItem').Setting.USLTargetLSL,
          description: i18n.$t('ControlItem').Setting.USLTargetLSLExplain,
        },
      },

      {
        element: '#updateFrequency',
        popover: {
          title: i18n.$t('ControlItem').Setting.updateFrequency,
          description: i18n.$t('ControlItem').Setting.updateFrequencyExplain,
        },
      },

      {
        element: '#customUpdateFrequency',
        popover: {
          title: i18n.$t('ControlItem').Setting.customUpdateFrequency,
          description: i18n.$t('ControlItem').Setting.customUpdateFrequencyExplain,
        },
      },

      {
        element: '#produceLevel',
        popover: {
          title: i18n.$t('ControlItem').Setting.processLevel,
          description: i18n.$t('ControlItem').Setting.processLevelExplain,
        },
      },

      {
        element: '#alertNotification',
        popover: {
          title: i18n.$t('ControlItem').Setting.alertNotification,
          description: i18n.$t('ControlItem').Setting.alertNotificationExplain,
        },
      },

      {
        element: '#threeAlert',
        popover: {
          title: i18n.$t('ControlItem').Setting.threeAlert,
          description: i18n.$t('ControlItem').Setting.threeAlertExplain,
        },
      },

      {
        element: '#autoLock',
        popover: {
          title: i18n.$t('ControlItem').Setting.autoLock,
          description: i18n.$t('ControlItem').Setting.autoLockExplain,
        },
      },

      {
        element: '#processReportCalculation',
        popover: {
          title: i18n.$t('ControlItem').Setting.processReportCalculation,
          description: i18n.$t('ControlItem').Setting.processReportCalculationExplain,
        },
      },

      {
        element: '#threeProcess',
        popover: {
          title: i18n.$t('ControlItem').Setting.threeProcess,
          description: i18n.$t('ControlItem').Setting.threeProcessExplain,
        },
      },

      {
        element: '#dynamiCcolumnSelect',
        popover: {
          title: i18n.$t('ControlItem').Setting.dynamiCcolumnSelect,
          description: `
          <p>${i18n.$t('ControlItem').Setting.dynamiCcolumnSelectExplain}</p>
          <p>${i18n.$t('ControlItem').Setting.dataImport}</p>
          <p>${i18n.$t('ControlItem').Setting.importMethod}</p>`,
        },
      },

      {
        element: '#controlChartSetting',
        popover: {
          title: i18n.$t('ControlItem').Setting.controlChartSetting,
          description: i18n.$t('ControlItem').Setting.controlChartSettingExplain,
        },
      },

      {
        element: '#dataType',
        popover: {
          title: i18n.$t('ControlItem').Setting.dataType,
          description: i18n.$t('ControlItem').Setting.dataTypeExplain,
        },
      },

      {
        element: '#calculateMethod',
        popover: {
          title: i18n.$t('ControlItem').Setting.calculateMethod,
          description: i18n.$t('ControlItem').Setting.calculateMethodExplain,
          onNextClick: () => {
            console.log('store.state.controlItem.chartIdList', store.state.controlItem.chartIdList);
            if (store.state.controlItem.chartIdList.length > 0) {
              const stopABCStepIndex = driverObj
                .getConfig()
                .steps.findIndex((step) => step.element === '#stopABC');
              driverObj.moveTo(stopABCStepIndex);
            } else {
              driverObj.moveNext();
            }
          },
        },
      },

      {
        element: '#controlChartSetting',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectDataTypeChart,
          description: i18n.$t('ControlItem').Setting.selectDataTypeChartPlease,
        },
      },

      {
        element: '#stopABC',
        popover: {
          title: i18n.$t('ControlItem').Setting.stopABC,
          description: i18n.$t('ControlItem').Setting.stopABCExplain,
        },
      },

      {
        element: '#UCL_LCL_Custom',
        popover: {
          title: i18n.$t('ControlItem').Setting.UCL_LCL_Custom,
          description: i18n.$t('ControlItem').Setting.UCL_LCL_CustomExplain,
        },
      },

      {
        element: '#ControlChartRule',
        popover: {
          title: i18n.$t('ControlItem').Setting.ControlChartRule,
          description: i18n.$t('ControlItem').Setting.ControlChartRuleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 管制項目設定之資料類型，包括管制圖規則
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpControlChartDataType(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#selectedTab',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('ControlItem').Setting.createDescription,
          onNextClick: () => {
            if (store.state.controlItem.tabShow === 'add') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();
              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#dataType',
        popover: {
          title: i18n.$t('ControlItem').Setting.dataType,
          description: i18n.$t('ControlItem').Setting.dataTypeExplain,
        },
      },

      {
        element: '#calculateMethod',
        popover: {
          title: i18n.$t('ControlItem').Setting.calculateMethod,
          description: i18n.$t('ControlItem').Setting.calculateMethodExplain,
        },
      },

      {
        element: '#chartList',
        popover: {
          title: i18n.$t('ControlItem').Setting.chartList,
          description: `
          <p>${i18n.$t('ControlItem').Setting.chartListExplain}</p>
          <p>${i18n.$t('ControlItem').Setting.chartListExplainMore}</p>`,
          onNextClick: () => {
            if (store.state.controlItem.chartIDList.length > 0) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').checkSelectData,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(4);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#calculateModel',
        popover: {
          title: i18n.$t('ControlItem').Setting.calculateModel,
          description: i18n.$t('ControlItem').Setting.calculateModelExplain,
        },
      },

      {
        element: '#stopABC',
        popover: {
          title: i18n.$t('ControlItem').Setting.stopABC,
          description: i18n.$t('ControlItem').Setting.stopABCExplain,
        },
      },

      {
        element: '#UCL_LCL_Custom',
        popover: {
          title: i18n.$t('ControlItem').Setting.UCL_LCL_Custom,
          description: i18n.$t('ControlItem').Setting.UCL_LCL_CustomExplain,
        },
      },

      {
        element: '#ControlChartRule',
        popover: {
          title: i18n.$t('ControlItem').Setting.ControlChartRule,
          description: i18n.$t('ControlItem').Setting.ControlChartRuleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫雙圖式說明
 * @param {*} i18n
 */
export function callHelpDoubleChart(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#selectedTab',
        popover: {
          title: i18n.$t('ControlItem').Setting.create,
          description: i18n.$t('ControlItem').Setting.createDescription,
          onNextClick: () => {
            if (store.state.controlItem.tabShow === 'add') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#dataType',
        popover: {
          title: i18n.$t('ControlItem').Setting.dataType,
          description: i18n.$t('ControlItem').Setting.dataTypeExplain,
          onNextClick: () => {
            if (store.state.controlItem.selectChartDataType === '1') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectAmountType,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#chartList',
        popover: {
          title: i18n.$t('ControlItem').Setting.chartList,
          description: `
          <p>${i18n.$t('ControlItem').Setting.chartListExplain}</p>
          <p>${i18n.$t('ControlItem').Setting.chartListExplainMore}</p>`,
          onNextClick: () => {
            if (store.state.controlItem.chartIDList.length > 0) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selctXBarChart,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(3);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#doubleChart_C',
        popover: {
          title: i18n.$t('ControlItem').Setting.doubleChartTitle,
          description: `
          <h5>${i18n.$t('ControlItem').Setting.sub_UCL_LCL}</h5>
          <p>${i18n.$t('ControlItem').Setting.sub_UCL_LCL_Explain}<p/>
          `,
        },
      },

      {
        element: '#doubleChart_S',
        popover: {
          title: i18n.$t('ControlItem').Setting.doubleChartTitle,
          description: `
          <h5>${i18n.$t('ControlItem').Setting.sub_USL_LSL}</h5>
          <p>${i18n.$t('ControlItem').Setting.sub_USL_LSL_Explain}<p/>
          `,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫複製
 * @param {*} i18n
 */
export function callHelpCopy(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.btnCopy',
        popover: {
          title: i18n.$t('ControlItem').Setting.copy,
          description: i18n.$t('ControlItem').Setting.copyDescription,
          onNextClick: () => {
            if (store.state.controlItem.copyDialogVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickCopyButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.copyDialog',
        popover: {
          title: i18n.$t('ControlItem').Setting.copy,
          description: i18n.$t('ControlItem').Setting.copyExplain,
        },
      },
      {
        element: '#selectPath',
        popover: {
          title: i18n.$t('ControlItem').Setting.copy,
          description: i18n.$t('ControlItem').Setting.copyExplainPath,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫重算
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpReCaculate(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.btnRecal',
        popover: {
          title: i18n.$t('ControlItem').Setting.reCaculate,
          description: i18n.$t('ControlItem').Setting.reCaculateDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEdit(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.btnEdit',
        popover: {
          title: i18n.$t('ControlItem').Setting.edit,
          description: i18n.$t('ControlItem').Setting.editDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDelete(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.levelSettingItem !== '' &&
              store.state.controlItem.levelSettingItem !== null
            ) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.btnDelete',
        popover: {
          title: i18n.$t('ControlItem').Setting.delete,
          description: i18n.$t('ControlItem').Setting.deleteDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫USL、Target、LSL 、OOS、OOC的名詞解釋
 * @param {*} i18n
 */
export function callHelpExplanationOfTheTerm(i18n) {
  const driverObj = driver({
    popoverClass: 'explanationOfTheTerm',
  });
  driverObj.highlight({
    popover: {
      title: i18n.$t('ControlItem').Setting.explanationOfTheTerm,
      description: `
      <p style="font-weight: bold; margin:2px 0;">${i18n.$t('ControlItem').Setting.USL}</p>
      <p>${i18n.$t('ControlItem').Setting.USL_Explain}<p/>

      <p style="font-weight: bold; margin:2px 0;">${i18n.$t('ControlItem').Setting.Target}</p>
      <p>${i18n.$t('ControlItem').Setting.TargetExplain}<p/>

      <p style="font-weight: bold; margin:2px 0;">${i18n.$t('ControlItem').Setting.LSL}</p>
      <p>${i18n.$t('ControlItem').Setting.LSL_Explain}<p/>

      <p style="font-weight: bold; margin:2px 0;">${i18n.$t('ControlItem').Setting.OOS}</p>
      <p>${i18n.$t('ControlItem').Setting.OOS_Explain}<p/>

      <p style="font-weight: bold; margin:2px 0;">${i18n.$t('ControlItem').Setting.OOC}</p>
      <p>${i18n.$t('ControlItem').Setting.OOC_Explain}<p/>
      `,
    },
  });
}

/**
 * 呼叫篩選管制項目資訊內的樹狀選單
 * @param {*} i18n
 */
export function callHelpFilterControlProject(i18n) {
  const driverObj = driver({
    animate: true,
    steps: [
      {
        element: '.filterRegion',
        popover: {
          title: i18n.$t('ControlItem').Information.filter,
          description: i18n.$t('ControlItem').Information.filterDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫管制項目資訊之檢視
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpViewControlProject(i18n, store) {
  let imgSource = null;
  let editImgSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = chartExplainTw;
      editImgSource = informationEditTw;
      break;

    case 'en':
      imgSource = chartExplainEn;
      editImgSource = informationEditEn;
      break;

    case 'cn':
      imgSource = chartExplainCn;
      editImgSource = informationEditCn;
      break;

    default:
      imgSource = chartExplainTw;
      editImgSource = informationEditTw;
      break;
  }

  let videoSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      videoSource = videoMenuOtherFunctionTw;
      break;

    case 'en':
      videoSource = videoMenuOtherFunctionEn;
      break;

    case 'cn':
      videoSource = videoMenuOtherFunctionCn;
      break;

    default:
      videoSource = videoMenuOtherFunctionTw;
      break;
  }

  const video = `
    <p>${i18n.$t('Dashboard').MenuOtherFunctionEnableEdit}</p>
    <video width="800" controls>
      <source src='${videoSource}' type="video/mp4">
    </video>`;

  const imgExplain = `
  <table>
    <tr>
      <td>
        <img src='${imgSource}' width="900"/>
      </td>
      <td>
        <p style='font-weight: bold; margin:2px 0;'>1.
          ${i18n.$t('ControlItem').Information.chartSwitch}
        </p>
        <p>
          ${i18n.$t('ControlItem').Information.chartSwitchExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>2.
          ${i18n.$t('ControlItem').Information.hirePointSwitch}
        </p>
        <p>
          ${i18n.$t('ControlItem').Information.hirePointSwitchExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>3.
          ${i18n.$t('ControlItem').Information.seasonLineReview}
        </p>

        <p>
          ${i18n.$t('ControlItem').Information.seasonLineReviewExplain}
        </p>
        <p style='font-weight: bold; margin:2px 0;'>4.
          ${i18n.$t('ControlItem').Information.ruleReview}
        </p>
        <p>
          ${i18n.$t('ControlItem').Information.ruleReviewExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>5.
          ${i18n.$t('ControlItem').Information.sampleReview}
        </p>
        <p>
          ${i18n.$t('ControlItem').Information.sampleReviewExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>6.Indicators</p>
        <p>${i18n.$t('ControlItem').Information.IndicatorsExplain}</p>
      </td>
    </tr>
  </table>
  `;

  const editImgExplain = `
  <table>
    <tr>${i18n.$t('ControlItem').Information.editExplain}</tr>
    <tr>
      <td>
        <img src='${editImgSource}' width="900"/>
      </td>
    </tr>
  </table>`;

  const driverObj = driver({
    animate: true,
    steps: [
      {
        element: '.filter-tree.mt-2',
        popover: {
          title: i18n.$t('ControlItem').Setting.selectTree,
          description: i18n.$t('ControlItem').Setting.selectTreeDescription,
          onNextClick: () => {
            if (
              store.state.controlItem.selectedDataItem !== '' &&
              store.state.controlItem.selectedDataItem !== null
            ) {
              if (store.state.controlItem.controlIdList.length === 0) {
                driverObj.destroy();

                ElMessage({
                  showClose: true,
                  message: i18n.$t('ControlItem').Setting.addInControlItemSettingsFirst,
                  type: 'error',
                  duration: 3000,
                });

                setTimeout(() => {
                  driverObj.drive();
                }, 3000);
              } else {
                driverObj.moveNext();
              }
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Setting.selectTreeDescription,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.btnView',
        popover: {
          title: i18n.$t('Button').view,
          description: i18n.$t('ControlItem').Information.viewExplain,
          onNextClick: () => {
            if (store.state.controlItem.selectedOneControlTab === null) {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickViewButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            } else {
              driverObj.moveNext();
            }
          },
        },
      },

      {
        element: '#chartFilter',
        popover: {
          title: i18n.$t('ControlItem').Information.drawFilter,
          description: i18n.$t('ControlItem').Information.drawFilterExplain,
        },
      },

      {
        popover: {
          element: '#tab-dataGraphic',
          title: i18n.$t('ControlItem').Information.drawData,
          description: imgExplain,
          popoverClass: 'imgExplain',
          side: 'left',
          align: 'start',
          onPrevClick: () => {
            if (store.state.controlItem.controlItemSelectedTabName === 'dataGraphic') {
              driverObj.movePrevious();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Information.clickChartFilterTabFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(3);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.plotlyImg',
        popover: {
          title: i18n.$t('ControlItem').Information.sampleReview,
          description: i18n.$t('ControlItem').Information.sampleReviewExplain,
        },
      },

      {
        element: '#classTabs',
        popover: {
          title: i18n.$t('ControlItem').Information.originalData,
          description: i18n.$t('ControlItem').Information.clickOriginalDataTab,
          onNextClick: () => {
            if (store.state.controlItem.controlItemSelectedTabName === 'dataProcessing') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').Information.clickOriginalDataTabFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(5);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#downloadCSV',
        popover: {
          title: i18n.$t('ControlItem').Information.dataDownload,
          description: i18n.$t('ControlItem').Information.dataDownloadExplain,
        },
      },

      {
        element: '#editOrViewBtn',
        popover: {
          title: i18n.$t('ControlItem').Information.edit,
          description: editImgExplain,
          popoverClass: 'imgEditExplain',
          side: 'top',
          align: 'center',
        },
      },

      {
        element: '#menu',
        popover: {
          side: 'top',
          align: 'center',
          title: i18n.$t('Dashboard').MenuOtherFunction,
          description: video,
          popoverClass: 'videoExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫隱藏點開啟
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpHidePoionOpen(i18n, store) {
  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = hidePointOpenTw;
      break;

    case 'en':
      imgSource = hidePointOpenEn;
      break;

    case 'cn':
      imgSource = hidePointOpenCn;
      break;

    default:
      imgSource = hidePointOpenTw;
      break;
  }

  const imgExplain = `
  <img src='${imgSource}' width="900"/>
  <p style='font-weight: bold; margin:2px 0;'>1.${i18n.$t('ControlItem').Information.preview}</p>
  <p>${i18n.$t('ControlItem').Information.previewExplain}</p>
  <p style='font-weight: bold; margin:2px 0;'>2.${
    i18n.$t('ControlItem').Information.singleChartHide
  }</p>
  <p>${i18n.$t('ControlItem').Information.singleChartHideExplain}</p>
  <p style='font-weight: bold; margin:2px 0;'>3.${
    i18n.$t('ControlItem').Information.allChartHide
  }</p>
  <p>${i18n.$t('ControlItem').Information.allChartHideExplain}</p>
  <p style='font-weight: bold; margin:2px 0;'>4.${
    i18n.$t('ControlItem').Information.hidePointList
  }</p>
  <p>${i18n.$t('ControlItem').Information.hidePointListExplain}</p>`;

  const driverObj = driver({
    animate: true,
    steps: [
      {
        popover: {
          title: i18n.$t('ControlItem').Information.hidePointOpen,
          description: imgExplain,
          popoverClass: 'imgExplain',
          side: 'top',
          align: 'center',
        },
      },

      {
        element: '#menu',
        popover: {
          title: i18n.$t('ControlItem').Information.topRightMenu,
          description: i18n.$t('ControlItem').Information.topRightMenuExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫點擊圖表上之樣本點後的重點說明
 * @param {*} i18n
 * @param {*} store
 */
export function clickChartSamplePoint(i18n, store) {
  let imgSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = chartSamplePointTw;
      break;

    case 'en':
      imgSource = chartSamplePointEn;
      break;

    case 'cn':
      imgSource = chartSamplePointCn;
      break;

    default:
      imgSource = chartSamplePointTw;
      break;
  }

  let imgMeasureSource = '';
  switch (store.state.lang) {
    case 'zhtw':
      imgMeasureSource = editMeasureValueTw;
      break;

    case 'en':
      imgMeasureSource = editMeasureValueEn;
      break;

    case 'cn':
      imgMeasureSource = editMeasureValueCn;
      break;

    default:
      imgMeasureSource = editMeasureValueTw;
      break;
  }

  const imgExplain = `
  <table>
    <tr>
      <td>
        <img src='${imgSource}' width="790"/>
      </td>
      <td>
          <p style='font-weight: bold; margin:2px 0;'>1.
            ${i18n.$t('ControlItem').Information.alertProcess}
          </p>
          <p>
            ${i18n.$t('ControlItem').Information.alertProcessExplain}
          </p>

          <p style='font-weight: bold; margin:2px 0;'>2.
            ${i18n.$t('ControlItem').Information.calculateSource}
          </p>
          <p>
            ${i18n.$t('ControlItem').Information.calculateSourceExplain}
          </p>

          <p style='font-weight: bold; margin:2px 0;'>3.
            ${i18n.$t('ControlItem').Information.editMeasureValue}
          </p>
          <p>${i18n.$t('ControlItem').Information.editMeasureValueExplain}</p>
      </td>
    </tr>
  </table>
  `;

  const imgExplainEditMeasureValue = `
    <img src='${imgMeasureSource}' width="600"/>
    <p>
      ${i18n.$t('ControlItem').Information.adjustOrginMeasureValue}
    </p>`;

  const driverObj = driver({
    animate: true,
    steps: [
      {
        popover: {
          title: i18n.$t('ControlItem').Information.clickChartSamplePoint,
          description: imgExplain,
          popoverClass: 'imgExplainSamplePoint',
          side: 'top',
          align: 'center',
        },
      },
      {
        popover: {
          title: i18n.$t('ControlItem').Information.editMeasureValue,
          description: imgExplainEditMeasureValue,
          popoverClass: 'imgExplainSamplePoint',
        },
      },
      {
        element: '#menu',
        popover: {
          title: i18n.$t('ControlItem').Information.enableEditFunction,
          description: i18n.$t('ControlItem').Information.enableEditFunctionExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制項目寫入
 * @param {*} i18n
 */
export function callControlItemEntry(i18n) {
  const htmlContent = `
  <p>${i18n.$t('ControlItem').ControlItemEntry.ManualEntryExplain}</p>
  <p>${i18n.$t('ControlItem').ControlItemEntry.MeasureValue}</p>
  `;
  const driverObj = driver({
    animate: true,
    steps: [
      {
        element: '#manualEntry',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.ManualEntry,
          description: i18n.$t('ControlItem').ControlItemEntry.ManualDescription,
        },
      },

      {
        element: '#manualEntry',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.selectManualEntry,
          description: htmlContent,
          side: 'bottom',
          align: 'end',
        },
      },

      {
        element: '#dataImport',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.DataImport,
          description: i18n.$t('ControlItem').ControlItemEntry.DataImportDescription,
        },
      },

      {
        element: '#SubControlItems',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.SubControlItems,
          description: i18n.$t('ControlItem').ControlItemEntry.SubControlItemsDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制項目寫入-資料匯入
 * @param {*} i18n
 */
export function callDataImport(i18n, store) {
  let firstDescription = '';
  if (
    store.state.controlItem.dataImportControlItem === '' ||
    store.state.controlItem.dataImportControlItem === null
  ) {
    firstDescription = i18n.$t('ControlItem').ControlItemEntry.selectDataImport;
  } else {
    firstDescription = i18n.$t('ControlItem').ControlItemEntry.confirmSelectDataImport;
  }

  const driverObj = driver({
    animate: true,
    steps: [
      {
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.DataImport,
          description: firstDescription,
          onPopoverRender: () => {
            if (
              store.state.controlItem.dataImportControlItem === '' ||
              store.state.controlItem.dataImportControlItem === null
            ) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            } else {
              console.log('確認已選取資料匯入的項目');
            }
          },
        },
      },
      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.exampleDownload,
          description: i18n.$t('ControlItem').ControlItemEntry.exampleExplain,
        },
      },

      {
        element: '.btn-confirm.ms-3',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.writeExample,
          description: i18n.$t('ControlItem').ControlItemEntry.writeExampleExplain,
        },
      },

      {
        element: '#selectFile',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.selectFile,
          description: i18n.$t('ControlItem').ControlItemEntry.selectFileExplain,
        },
      },

      {
        element: '#uploadFile',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.uploadFile,
          description: i18n.$t('ControlItem').ControlItemEntry.uploadFileExplain,
        },
      },

      {
        element: '.table-wrap',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.uploadFile,
          description: `
          <p>${i18n.$t('ControlItem').ControlItemEntry.confirmUploadFileFinished}</p>
          <p>${i18n.$t('ControlItem').ControlItemEntry.errorExcept}</p>`,
        },
      },

      {
        element: '#filterBtn',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.filter,
          description: i18n.$t('ControlItem').ControlItemEntry.filterExplain,
        },
      },

      {
        element: '#refreshBtn',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.refresh,
          description: i18n.$t('ControlItem').ControlItemEntry.refreshExplain,
        },
      },

      {
        element: '#restartBtn',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.restart,
          description: i18n.$t('ControlItem').ControlItemEntry.restartExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制項目寫入 Multi-Data-Import
 * @param {*} i18n
 * @param {*} store
 */
export function callMultiDataImport(i18n, store) {
  let imgSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = multiDataImportTw;
      break;

    case 'en':
      imgSource = multiDataImportEn;
      break;

    case 'cn':
      imgSource = multiDataImportCn;
      break;

    default:
      imgSource = multiDataImportTw;
      break;
  }

  const imgExplain = `
   <img src="${imgSource}" width="800"/>
   <p>${i18n.$t('ControlItem').ControlItemEntry.MultiDataImport}</p>
   `;

  const driverObj = driver({
    animate: true,

    steps: [
      {
        element: '#dataImport',
        popover: {
          title: i18n.$t('ControlItem').ControlItemEntry.ControlItemEntryBatchImport,
          description: imgExplain,
          popoverClass: 'classImportStatus',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫樣本管理-先介紹隱藏點處理
 * @param {*} i18n
 * @param {*} store
 */
export function callSampleManagement(i18n, store) {
  let imgSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = hiddenPointProcessingTw;
      break;

    case 'en':
      imgSource = hiddenPointProcessingEn;
      break;

    case 'cn':
      imgSource = hiddenPointProcessingCn;
      break;

    default:
      imgSource = hiddenPointProcessingTw;
      break;
  }

  let judgeTabText = '';
  if (store.state.controlItem.sampleManagementActiveTabName === 'A_7_1') {
    judgeTabText = i18n.$t('ControlItem').SampleSetting.ConfirmClickHiddenPointProcessOK;
  } else {
    judgeTabText = i18n.$t('ControlItem').SampleSetting.clickHiddenPointProcessFirst;
  }

  const driverObj = driver({
    animate: true,

    steps: [
      {
        element: '#tab-A_7_1',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.hiddenPointProcess,
          description: `
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointProcessDescription}</p>
          <p>${judgeTabText}</p>`,
          onPopoverRender: () => {
            if (store.state.controlItem.sampleManagementActiveTabName === 'A_7_1') {
              console.log('確認已按隱藏點處理');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchitem.ms-2.noisePointProcess',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.hiddenPointFilter,
          description: `
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointFilterExplain}</p>
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointFilterExplainCondition}</p>
          `,
        },
      },

      {
        element: '.editBtn',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.hiddenPointEdit,
          description: `${
            store.state.controlItem.hiddenPointDataTable.length === 0
              ? `<img src="${imgSource}"  width="1024"/>`
              : ''
          }
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointEditExplain}</p>
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointEditExplainMore}</p>
          `,
          popoverClass: 'imgExplain',
        },
      },

      {
        element: '.deleteBtn',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.hiddenPointDelete,
          description: `${
            store.state.controlItem.hiddenPointDataTable.length === 0
              ? `<img src="${imgSource}"  width="1024"/>`
              : ''
          }
          <p>${i18n.$t('ControlItem').SampleSetting.hiddenPointDeleteExplain}</p>`,
          popoverClass: 'imgExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫樣本管理-編輯點處理
 * @param {*} i18n
 * @param {*} store
 */
export function callSampleManagementEditPointProcess(i18n, store) {
  let judgeTabText = '';
  if (store.state.controlItem.sampleManagementActiveTabName === 'A_7_2') {
    judgeTabText = i18n.$t('ControlItem').SampleSetting.ConfirmClickEditPointProcessOK;
  } else {
    judgeTabText = i18n.$t('ControlItem').SampleSetting.clickEditPointProcessFirst;
  }

  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = sampleMngListTw;
      break;

    case 'en':
      imgSource = sampleMngListEn;

      break;

    case 'cn':
      imgSource = sampleMngListCn;

      break;

    default:
      imgSource = sampleMngListTw;
      break;
  }

  let editDescription = '';
  if (store.state.controlItem.modifyPointDataTable.length > 0) {
    editDescription = i18n.$t('ControlItem').SampleSetting.editPointProcessViewExplain;
  } else {
    editDescription = `
    <img src='${imgSource}' width="800"/>
    <p>${i18n.$t('ControlItem').SampleSetting.editPointProcessViewExplain}</p>
    <p>${i18n.$t('ControlItem').SampleSetting.referenceControlItemInformationView}</p>`;
  }

  const driverObj = driver({
    animate: true,

    steps: [
      {
        element: '#tab-A_7_2',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.editPointProcess,
          description: `
          <p>${i18n.$t('ControlItem').SampleSetting.editPointProcessDescription}</p>
          <p>${judgeTabText}</p>
          `,
          onPopoverRender: () => {
            if (store.state.controlItem.sampleManagementActiveTabName === 'A_7_2') {
              console.log('確認已按編輯點處理');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.searchitem.ms-2.modifyPointProcess',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.editPointProcessFilter,
          description: `
          <p>${i18n.$t('ControlItem').SampleSetting.editPointProcessFilterExplain}</p>
          <p>${i18n.$t('ControlItem').SampleSetting.editPointProcessFilterExplainMore}</p>
          `,
          popoverClass: 'classExplain',
        },
      },
      {
        element: '.viewBtn',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.editPointProcessView,
          description: editDescription,
          popoverClass: 'editDescription',
          onPopoverRender: () => {
            if (store.state.controlItem.modifyPointDataTable.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },
      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('ControlItem').SampleSetting.editPointProcessDelete,
          description: i18n.$t('ControlItem').SampleSetting.editPointProcessDeleteExplain,
          popoverClass: 'classExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫管制線變更履歷
 * @param {*} i18n
 */
export function callControlLineChangeHistory(i18n, store) {
  let judgeTabText = '';
  if (store.state.controlItem.historyActiveTabName === 'A_4_1') {
    judgeTabText = i18n.$t('ControlItem').History.ConfirmClickControlLineChangeHistoryFirstOK;
  } else {
    judgeTabText = i18n.$t('ControlItem').History.ClickControlLineChangeHistoryFirst;
  }

  const tempList = store.state.controlItem.controlLineChangeLogDataList;
  let viewDescription = '';
  if (tempList.length > 0) {
    viewDescription = i18n.$t('ControlItem').History.ViewControlLineChangeHistoryExplain;
  } else {
    viewDescription = `
    <p>${i18n.$t('ControlItem').History.buildDatasourceStep}</p>
    <p>1.${i18n.$t('ControlItem').History.createDataFromControlItemSetting}</p>
    <p>2.${i18n.$t('ControlItem').History.createDataMethod}</p>
    <p>2.1.${i18n.$t('ControlItem').History.createDataMethod21}</p>
    <p>2.2.${i18n.$t('ControlItem').History.createDataMethod22}</p>
    <p>3.${i18n.$t('ControlItem').History.createDataMethod3}</p>
    `;
  }

  const driverObj = driver({
    steps: [
      {
        element: '.el-tabs__header.is-top',
        popover: {
          title: i18n.$t('ControlItem').History.ControlLineChangeHistory,
          description: `
          <p>${i18n.$t('ControlItem').History.ControlLineChangeHistoryExplain}</p>
          <p>${judgeTabText}</p>`,
          onPopoverRender: () => {
            if (store.state.controlItem.historyActiveTabName === 'A_4_1') {
              console.log('確認有按下管制線變更履歷');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchitem.controlLine',
        popover: {
          title: i18n.$t('ControlItem').History.FilterControlLineChangeHistory,
          description: i18n.$t('ControlItem').History.FilterControlLineChangeHistoryExplain,
        },
      },

      {
        element: '.btnView',
        popover: {
          title: i18n.$t('ControlItem').History.ViewControlLineChangeHistory,
          description: viewDescription,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '.btnDelete',
        popover: {
          title: i18n.$t('ControlItem').History.DeleteControlLineChangeHistory,
          description: i18n.$t('ControlItem').History.DeleteControlLineChangeHistoryExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制圖規則履歷
 * @param {*} i18n
 * @param {*} store
 */
export function callControlChartRuleHistory(i18n, store) {
  let judgeTabText = '';
  if (store.state.controlItem.historyActiveTabName === 'A_4_2') {
    judgeTabText = i18n.$t('ControlItem').History.ConfirmClickControlChartRuleHistoryFirstOK;
  } else {
    judgeTabText = i18n.$t('ControlItem').History.ClickControlChartRuleHistoryFirst;
  }

  const tempList = store.state.controlItem.controlChartRuleLogDataList;

  let viewDescription = '';
  if (tempList.length > 0) {
    viewDescription = i18n.$t('ControlItem').History.ViewControlChartRuleHistoryExplain;
  } else {
    viewDescription = `
    <p>${i18n.$t('ControlItem').History.buildDatasourceStep}</p>
    <p>1.${i18n.$t('ControlItem').History.createDataFromControlItemSetting}</p>
    <p>2.${i18n.$t('ControlItem').History.editControlItemSetting}</p>
    <p>3.${i18n.$t('ControlItem').History.createDataMethod}</p>
    <p>3.1.${i18n.$t('ControlItem').History.createDataMethod21}</p>
    <p>3.2.${i18n.$t('ControlItem').History.createDataMethod22}</p>
    `;
  }

  const driverObj = driver({
    steps: [
      {
        element: '#tab-A_4_2',
        popover: {
          title: i18n.$t('ControlItem').History.ControlChartRuleHistory,
          description: `
          <p>${i18n.$t('ControlItem').History.ControlChartRuleHistoryDescription}</p>
          <p>${judgeTabText}</p>
          `,
          onPopoverRender: () => {
            if (store.state.controlItem.historyActiveTabName === 'A_4_2') {
              console.log('確認有按下管制圖規則履歷');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchitem.ruleSpec',
        popover: {
          title: i18n.$t('ControlItem').History.FilterControlChartRuleHistory,
          description: i18n.$t('ControlItem').History.FilterControlChartRuleHistoryExplain,
          popoverClass: 'classExplain',
        },
      },

      {
        element: '.btnEdit',
        popover: {
          title: i18n.$t('ControlItem').History.ViewControlChartRuleHistory,
          description: viewDescription,
          popoverClass: 'classExplain',
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '#btnDelete',
        popover: {
          title: i18n.$t('ControlItem').History.DeleteControlChartRuleHistory,
          description: i18n.$t('ControlItem').History.DeleteControlChartRuleHistoryExplain,
          popoverClass: 'classExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫合圖查詢
 * @param {*} i18n
 * @param {*} store
 */
export function callCombinedQuery(i18n, store) {
  let judgeDataText = '';
  if (store.state.controlItem.chartTabList.length > 0) {
    judgeDataText = i18n.$t('ControlItem').CombinedQuery.ConfirmHadData;
  } else {
    judgeDataText = i18n.$t('ControlItem').CombinedQuery.ConfirmNoData;
  }

  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = combineChartTw;
      break;

    case 'en':
      imgSource = combineChartEn;
      break;

    case 'cn':
      imgSource = combineChartCn;
      break;

    default:
      imgSource = combineChartTw;
      break;
  }

  const imgExplain = `
  <table>
    <tr>
      <td>
        <img src="${imgSource}" width="1024" />
      </td>

      <td>
        <p style='font-weight: bold; margin:2px 0;'>
          1.${i18n.$t('ControlItem').CombinedQuery.ChartSwitch}
        </p>
        <p>
          ${i18n.$t('ControlItem').CombinedQuery.ChartSwitchExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>
          2.${i18n.$t('ControlItem').CombinedQuery.QuarterReview}
        </p>
        <p>
          ${i18n.$t('ControlItem').CombinedQuery.QuarterReviewExplain}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>
          3.${i18n.$t('ControlItem').CombinedQuery.ReviewOfJudgmentRules}
        </p>
        <p>
          ${i18n.$t('ControlItem').CombinedQuery.ReviewOfJudgmentRulesExplain}
        </p>

        <p>
          4.${i18n.$t('ControlItem').CombinedQuery.ExplainMain}
        </p>
        <p>
          5.${i18n.$t('ControlItem').CombinedQuery.ExplainSub}
        </p>

        <p style='font-weight: bold; margin:2px 0;'>
          6.Indicators
        </p>
        <p>
          ${i18n.$t('ControlItem').CombinedQuery.Indicators}
        </p>
      </td>
    </tr>
  </table>
  `;

  const driverObj = driver({
    steps: [
      {
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.name,
          description: judgeDataText,
          allowClose: false,
          onPopoverRender: () => {
            if (store.state.controlItem.chartTabList.length > 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }

              const closeBtn = document.querySelector('.driver-popover-close-btn');
              if (closeBtn) {
                closeBtn.setAttribute('style', 'cursor: not-allowed !important;');
              }
              setTimeout(() => {
                driverObj.moveTo(3);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.MainSubControlItem',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.MainSubControlItem,
          description: i18n.$t('ControlItem').CombinedQuery.MainSubControlItemExplain,
        },
      },

      {
        element: '#FilterChart',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.FilterChart,
          description: i18n.$t('ControlItem').CombinedQuery.FilterChartExplain,
          onNextClick: () => {
            if (store.state.controlItem.chartTabList.length > 0) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').CombinedQuery.SearchDataFirst,
                type: 'error',
                duration: 3000,
              });
            }
          },
        },
      },

      {
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.name,
          description: imgExplain,
          popoverClass: 'imgExplain',
          side: 'top',
          align: 'center',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫製程能力分析
 * @param {*} i18n
 * @param {*} store
 */
export function callProcessAnalysis(i18n, store) {
  const driverObj = driver({
    steps: [
      {
        element: '#tab-0',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Report,
          description: i18n.$t('ControlItem').ProcessAnalysis.ReportDescription,
        },
      },
      {
        element: '#tab-1',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Chart,
          description: i18n.$t('ControlItem').ProcessAnalysis.ChartDescription,
        },
      },
      {
        element: '#tab-2',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Abnormal,
          description: i18n.$t('ControlItem').ProcessAnalysis.AbnormalDescription,
          onNextClick: () => {
            if (store.state.controlItem.processAnalysisActiveTab === '0') {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').ProcessAnalysis.clickReportQueryFirst,
                type: 'error',
                duration: 3000,
              });
            }
          },
        },
      },

      {
        element: '#reportDate',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportDate,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportDateExplain,
        },
      },

      {
        element: '#reportType',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportType,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportTypeExplain,
        },
      },

      {
        element: '#reportControlItem',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportControlItem,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportControlItemExplain,
        },
      },

      {
        element: '#reportModel',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportModel,
          description: `
          <p>${i18n.$t('ControlItem').ProcessAnalysis.reportModelExplain}</p>
          <p>${i18n.$t('ControlItem').ProcessAnalysis.reportModelExplainDetail}</p>`,
        },
      },

      {
        element: '#btnSearch',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportFilter,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportFilterExplain,
        },
      },

      {
        element: '#btnAdvanceSearch',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearch,
          description: `
          <p>${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplain}</p>
          <p>${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplainDetail}</p>`,
        },
      },

      {
        element: '#reportDownload',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportDownload,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportDownloadExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫製程能力分析之進階搜尋
 * @param {*} i18n
 * @param {*} store
 */
export function callProcessAnalysisAdvanceSearch(i18n, store) {
  let message = '';
  console.log(
    'store.state.btnAdvanceSearchDisabled',
    store.state.controlItem.btnAdvanceSearchDisabled,
  );
  if (store.state.controlItem.btnAdvanceSearchDisabled === true) {
    message = i18n.$t('ControlItem').ProcessAnalysis.beforeReportAdvanceSearch;
  } else {
    message = i18n.$t('ControlItem').ProcessAnalysis.beforeClickReportAdvanceSearch;
  }

  const driverObj = driver({
    steps: [
      {
        element: '#btnAdvanceSearch',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearch,
          description: `${message}`,
          onPopoverRender: () => {
            if (store.state.controlItem.btnAdvanceSearchDisabled === true) {
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            } else if (store.state.controlItem.advanceSearchDialogVisible === true) {
              driverObj.destroy();
              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').ProcessAnalysis.confirmAdvanceSearchDialog,
                type: 'success',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.moveTo(2);
              }, 1000);
            }
          },
        },
      },
      {
        element: '#btnAdvanceSearch',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearch,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplain,
          onPopoverRender: () => {
            if (store.state.controlItem.advanceSearchDialogVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('ControlItem').ProcessAnalysis.beforeClickReportAdvanceSearch,
                type: 'error',
                duration: 3000,
              });
            }
          },
        },
      },
      {
        element: '#advanceSearchDialog',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearch,
          description: `
          <p>1.${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplainMore1}</p>
          <p>2.${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplainMore2}</p>
          <p>3.${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplainMore3}</p>
          <p>4.${i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplainMore4}</p>
          <img src=${advanceSearchDynamicFields}>`,
          popoverClass: 'advanceSearchExplain',
          onPopoverRender: (popover) => {
            const prevBtn = popover.footerButtons.querySelector('.driver-popover-prev-btn');
            if (prevBtn) prevBtn.style.display = 'none';
          },
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫製程能力分析-圖表查詢
 * @param {*} i18n
 * @param {*} store
 */
export function callProcessAnalysisChartQuery(i18n, store) {
  let message = '';
  if (store.state.controlItem.processAnalysisActiveTab === '1') {
    message = i18n.$t('ControlItem').ProcessAnalysis.ChartDescription;
  } else {
    message = i18n.$t('ControlItem').ProcessAnalysis.clickChartQueryFirst;
  }

  const imgTable = `
  <table>
    <tr>
      <td>
        <img src="${CPKBoxImg}" width="900px"/>
      </td>
      <td>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBox}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBoxUp}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBoxDown}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBoxUp4}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBoxDown4}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainBoxMedian}</p>
      </td>
    </tr>

    <tr>
      <td>
        <img src="${runChartImg}" width="900px"/>
      </td>
      <td>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainCPK_Trend}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainPPK_Trend}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainRunChart}</p>
        <p>${i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplainRunChartMore}</p>
      </td>
    </tr>
  </table>
  `;

  const driverObj = driver({
    steps: [
      {
        element: '#tab-1',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Chart,
          description: message,
          onPopoverRender: () => {
            if (store.state.controlItem.processAnalysisActiveTab === '1') {
              // console.log('確認是圖表查詢頁籤');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#chartDate',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.chartDate,
          description: i18n.$t('ControlItem').ProcessAnalysis.chartDateExplain,
        },
      },

      {
        element: '#chartType',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.chartType,
          description: i18n.$t('ControlItem').ProcessAnalysis.chartTypeExplain,
        },
      },

      {
        element: '#controlItem',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportControlItem,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportControlItemExplain,
        },
      },

      {
        element: '#dimension',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.dimension,
          description: i18n.$t('ControlItem').ProcessAnalysis.dimensionExplain,
        },
      },

      {
        element: '#filter',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportFilter,
          description: i18n.$t('ControlItem').ProcessAnalysis.reportFilterExplain,
        },
      },

      {
        // element: '#chartTabs',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.chartType,
          description: imgTable,
          popoverClass: 'chartTabsExplainFrame',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫製程能力分析-Abnormal
 * @param {*} i18n
 * @param {*} store
 */
export function callProcessAnalysisAbnormal(i18n, store) {
  let message = '';
  if (store.state.controlItem.processAnalysisActiveTab === '2') {
    message = i18n.$t('ControlItem').ProcessAnalysis.AbnormalDescription;
  } else {
    message = i18n.$t('ControlItem').ProcessAnalysis.clickAbnormalFirst;
  }

  let paretoImgRegion = null;

  const storeParetoGraph = store.state.controlItem.paretoGraph;
  const storeParetoHistogram = store.state.controlItem.paretoHistogram;

  if (storeParetoGraph === null && storeParetoHistogram === null) {
    paretoImgRegion = `
    <tr>
      <td>

      </td>
      <td>
        <img src="${paretoImg}" width="700">
      </td>
    </tr>`;
  } else {
    console.log('物件不是null');
    if (storeParetoGraph.length === 0 && storeParetoHistogram.length === 0) {
      paretoImgRegion = `
        <tr>
          <td>

          </td>
          <td>
            <img src="${paretoImg}" width="700">
          </td>
        </tr>`;
    } else {
      console.log('storeParetoGraph和storeParetoHistogram的資料長度大於0');
      if (
        storeParetoGraph.x === undefined &&
        storeParetoGraph.y === undefined &&
        storeParetoHistogram.x === undefined &&
        storeParetoHistogram.y === undefined
      ) {
        paretoImgRegion = `
        <tr>
          <td>

          </td>
          <td>
            <img src="${paretoImg}" width="700">
          </td>
        </tr>`;
      } else {
        console.log('物件不是undefined且沒x,y的資料');
        if (
          storeParetoGraph.x.length === 0 &&
          storeParetoGraph.y.length === 0 &&
          storeParetoHistogram.x.length === 0 &&
          storeParetoHistogram.y.length === 0
        ) {
          paretoImgRegion = `
          <tr>
            <td>

            </td>
            <td>
              <img src="${paretoImg}" width="700">
            </td>
          </tr>`;
        } else {
          paretoImgRegion = '';
        }
      }
    }
  }

  const driverObj = driver({
    steps: [
      {
        element: '#tab-2',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Abnormal,
          description: message,
          onPopoverRender: () => {
            if (store.state.controlItem.processAnalysisActiveTab === '2') {
              console.log('確認是異常分析頁籤');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#abnormalDate',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.AbnormalDate,
          description: i18n.$t('ControlItem').ProcessAnalysis.AbnormalDateExplain,
        },
      },

      {
        element: '#abnormalChartType',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.AbnormalChartType,
          description: i18n.$t('ControlItem').ProcessAnalysis.AbnormalChartTypeExplain,
        },
      },

      {
        element: '#abnormalControlItemType',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.AbnormalControlItemType,
          description: i18n.$t('ControlItem').ProcessAnalysis.AbnormalControlItemTypeExplain,
        },
      },

      {
        element: '#btnFilterAbnormal',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.reportFilter,
          description: `
          <p>${i18n.$t('ControlItem').ProcessAnalysis.AbnormalFilterExplain}</p>
          <p>${i18n.$t('ControlItem').ProcessAnalysis.abnormalFilterExplainMore}</p>`,
        },
      },

      {
        element: '#tabAbnormal',
        popover: {
          title: i18n.$t('ControlItem').ProcessAnalysis.Abnormal,
          description: `
          <table>
            <tr>
              <td>
                <p style='font-weight: bold;'>
                  ${i18n.$t('ControlItem').ProcessAnalysis.alertCount}
                </p>
              </td>
              <td>
                <p>${i18n.$t('ControlItem').ProcessAnalysis.alertCountExplain}</p>
              </td>
            </tr>

            <tr>
              <td>
                <p style='font-weight: bold;'>
                  ${i18n.$t('ControlItem').ProcessAnalysis.abnormalRate}
                </p>
              </td>
              <td>
                <p>${i18n.$t('ControlItem').ProcessAnalysis.abnormalRateExplain}</p>
              </td>
            </tr>

            <tr>
              <td>
                <p style='font-weight: bold;'>
                  ${i18n.$t('ControlItem').ProcessAnalysis.abnormalReason}
                </p>
              </td>
              <td>
                <p>${i18n.$t('ControlItem').ProcessAnalysis.abnormalReasonExplain}</p>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <p>${i18n.$t('ControlItem').ProcessAnalysis.abnormalExplainMore1}</p>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <p>${i18n.$t('ControlItem').ProcessAnalysis.abnormalExplainMore2}</p>
              </td>
            </tr>

            ${paretoImgRegion}
          </table>
          `,
          popoverClass: 'chartTabsExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * X-Bar 圖表說明，包含設定、輸入資料範例、呈現結果
 * @param {*} i18n
 * @param {*} store
 */
export function callxBarChart(i18n, store) {
  let imgSource = null;
  let imgSourceStep2 = null;
  let inputData1 = null;
  let inputData2 = null;
  let inputData3 = null;
  let inputData4 = null;
  let inputData5 = null;
  let imgResult = null;

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = xBarChartSettingTw;
      imgSourceStep2 = xBarChartSettingTw2;
      inputData1 = XBarChartInputDataTw1;
      inputData2 = XBarChartInputDataTw2;
      inputData3 = XBarChartInputDataTw3;
      inputData4 = XBarChartInputDataTw4;
      inputData5 = XBarChartInputDataTw5;
      break;

    case 'en':
      imgSource = xBarChartSettingEn;
      imgSourceStep2 = xBarChartSettingEn2;
      inputData1 = XBarChartInputDataEn1;
      inputData2 = XBarChartInputDataEn2;
      inputData3 = XBarChartInputDataEn3;
      inputData4 = XBarChartInputDataEn4;
      inputData5 = XBarChartInputDataEn5;
      imgResult = XBarChartIResultEn;
      break;

    default:
      imgSource = xBarChartSettingTw;
      imgSourceStep2 = xBarChartSettingTw2;
      inputData1 = XBarChartInputDataTw1;
      inputData2 = XBarChartInputDataTw2;
      inputData3 = XBarChartInputDataTw3;
      inputData4 = XBarChartInputDataTw4;
      inputData5 = XBarChartInputDataTw5;
      imgResult = XBarChartIResultTw;
      break;
  }

  const imgExplain = `
   <img src="${imgSource}" width="900"/>
   <p>${i18n.$t('statisticalControlChart').imgExplain}</p>
   `;

  const imgExplainStep2 = `
   <img src="${imgSourceStep2}" width="900"/>
   <p></p>
   `;

  const imgExplainInputData1 = `
   <img src="${inputData1}" width="900"/>
   <p>${i18n.$t('statisticalControlChart').inputData1}</p>
   `;

  const imgExplainInputData2 = `
   <img src="${inputData2}" width="900"/>
   <p></p>
   `;

  const imgExplainInputData3 = `
   <img src="${inputData3}" width="900"/>
   <p></p>
   `;

  const imgExplainInputData4 = `
   <img src="${inputData4}" width="900"/>
   <p></p>
   `;

  const imgExplainInputData5 = `
   <img src="${inputData5}" width="900"/>
   <p></p>
   `;

  const inputDataExample = `
   <table style="border-collapse: collapse; text-align: center;">
        <thead>
            <tr>
                <th style="border: 1px solid #ccc;" rowspan="2">
                  ${i18n.$t('statisticalControlChart').lot}
                </th>
                <th style="border: 1px solid #ccc;" colspan="5"> ${i18n.$t('A_2').measure}</th>
            </tr>

            <tr>
                <th style="border: 1px solid #ccc;">1</th>
                <th style="border: 1px solid #ccc;">2</th>
                <th style="border: 1px solid #ccc;">3</th>
                <th style="border: 1px solid #ccc;">4</th>
                <th style="border: 1px solid #ccc;">5</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="border: 1px solid #ccc;">1</td>
                <td style="border: 1px solid #ccc;">9.8</td>
                <td style="border: 1px solid #ccc;">10.0</td>
                <td style="border: 1px solid #ccc;">10.1</td>
                <td style="border: 1px solid #ccc;">9.9</td>
                <td style="border: 1px solid #ccc;">10.2</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ccc;">2</td>
                <td style="border: 1px solid #ccc;">10.1</td>
                <td style="border: 1px solid #ccc;">10.2</td>
                <td style="border: 1px solid #ccc;">10.0</td>
                <td style="border: 1px solid #ccc;">9.9</td>
                <td style="border: 1px solid #ccc;">10.3</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ccc;">3</td>
                <td style="border: 1px solid #ccc;">9.9</td>
                <td style="border: 1px solid #ccc;">9.8</td>
                <td style="border: 1px solid #ccc;">10.0</td>
                <td style="border: 1px solid #ccc;">10.1</td>
                <td style="border: 1px solid #ccc;">9.7</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ccc;">4</td>
                <td style="border: 1px solid #ccc;">10.0</td>
                <td style="border: 1px solid #ccc;">10.1</td>
                <td style="border: 1px solid #ccc;">10.2</td>
                <td style="border: 1px solid #ccc;">9.8</td>
                <td style="border: 1px solid #ccc;">9.9</td>
            </tr>
            <tr>
                <td style="border: 1px solid #ccc;">5</td>
                <td style="border: 1px solid #ccc;">10.2</td>
                <td style="border: 1px solid #ccc;">10.0</td>
                <td style="border: 1px solid #ccc;">9.8</td>
                <td style="border: 1px solid #ccc;">10.1</td>
                <td style="border: 1px solid #ccc;">9.9</td>
            </tr>
        </tbody>
    </table>
   `;

  const imgExplaiinResult = `
   <img src="${imgResult}" width="1024"/>
   <p></p>
   `;

  const driverObj = driver({
    animate: true,

    steps: [
      {
        element: '#One',
        popover: {
          title: i18n.$t('statisticalControlChart').XBarInputExample,
          description: imgExplain,
          popoverClass: 'imgExplainForChart',
        },
      },
      {
        element: '#Two',
        popover: {
          title: `${i18n.$t('statisticalControlChart').selectVariable}XBar-Chart`,
          description: imgExplainStep2,
          popoverClass: 'imgExplainForChart',
        },
      },
      {
        element: '#Three',
        popover: {
          title: i18n.$t('statisticalControlChart').inputDataManual1,
          description: imgExplainInputData1,
          popoverClass: 'imgExplainForChart',
        },
      },
      {
        element: '#Four',
        popover: {
          title: i18n.$t('statisticalControlChart').inputDataManual2,
          description: imgExplainInputData2,
          popoverClass: 'imgExplainForChart',
        },
      },
      {
        element: '#Five',
        popover: {
          title: i18n.$t('statisticalControlChart').inputDataManual3,
          description: imgExplainInputData3,
          popoverClass: 'imgExplainForChart',
        },
      },

      {
        element: '#Six',
        popover: {
          title: i18n.$t('statisticalControlChart').inputDataManual4,
          description: imgExplainInputData4,
          popoverClass: 'imgExplainForChart',
        },
      },

      {
        element: '#Seven',
        popover: {
          title: i18n.$t('statisticalControlChart').inputDataManual5,
          description: imgExplainInputData5,
          popoverClass: 'imgExplainForChart',
        },
      },

      {
        element: '#Eight',
        popover: {
          title: i18n.$t('statisticalControlChart').dataExample,
          description: inputDataExample,
        },
      },
      {
        element: '#Nine',
        popover: {
          onPopoverRender: (popover) => {
            popover.wrapper.style.setProperty('max-width', 'calc(100vw - 32px)', 'important');
            popover.wrapper.style.width = '1064px';
            const img = popover.description.querySelector('img');
            if (img) {
              img.style.maxWidth = '100%';
              img.style.height = 'auto';
            }
          },
          title: i18n.$t('statisticalControlChart').viewChartResult,
          description: imgExplaiinResult,
          popoverClass: 'imgExplainForChart',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}
